import React from 'react';
import { 
  Box, 
  Button, 
  Chip, 
  Tooltip, 
  useTheme 
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
import { useLayout } from '../../contexts/LayoutContext';

interface LayoutToggleProps {
  onToggle?: () => void;
  showLabel?: boolean;
}

const LayoutToggle: React.FC<LayoutToggleProps> = ({ onToggle, showLabel = false }) => {
  const theme = useTheme();
  const { dashboardLayout, toggleLayout } = useLayout();
  const isSimplified = dashboardLayout === 'simplified';

  const handleToggle = () => {
    // FIXED: Use context instead of mutating static config
    toggleLayout();
    
    // IMPROVED: No more page reload needed!
    if (onToggle) {
      onToggle();
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {showLabel && (
        <Chip 
          label={isSimplified ? 'Simplified' : 'Original'} 
          size="small" 
          color={isSimplified ? 'primary' : 'default'}
          variant="outlined"
        />
      )}
      
      <Tooltip title={`Switch to ${isSimplified ? 'original' : 'simplified'} layout`}>
        <Button
          variant="outlined"
          size="small"
          onClick={handleToggle}
          startIcon={isSimplified ? <DashboardIcon /> : <ViewCompactIcon />}
          sx={{
            minWidth: 'auto',
            px: 1.5,
            py: 0.5,
            fontSize: '0.75rem',
            borderColor: theme.palette.mode === 'dark' 
              ? 'rgba(255, 255, 255, 0.23)' 
              : undefined,
            color: theme.palette.mode === 'dark' 
              ? 'rgba(255, 255, 255, 0.87)' 
              : undefined,
            '&:hover': {
              borderColor: theme.palette.mode === 'dark' 
                ? 'rgba(255, 255, 255, 0.4)' 
                : undefined,
              backgroundColor: theme.palette.mode === 'dark' 
                ? 'rgba(255, 255, 255, 0.05)' 
                : undefined
            }
          }}
        >
          {showLabel ? (isSimplified ? 'Original' : 'Simplified') : ''}
        </Button>
      </Tooltip>
    </Box>
  );
};

export default LayoutToggle; 